import i18n from "@/i18n";
import {FormOption} from "@/types/formOption";
import '@/extensions/formOptions.extensions';

export enum ActivityArea {
  PurchaseSaleAndRental = 'ACHAT, VENTE, LOCATION',
  Noise = 'ACOUSTIQUE / INSONORISATION',
  SecurityGuard = "AGENTS DE SÉCURITÉ",
  AirConditioning = 'AIR CLIMATISÉ',
  Alarm = 'ALARME',
  LandscapeDesignAndMaintenance = 'AMÉNAGEMENT PAYSAGER ET ENTRETIEN',
  Architect = 'ARCHITECTE',
  LandSurveyor = 'ARPENTEUR-GÉOMÈTRE',
  Elevator = 'ASCENSEUR',
  Paving = 'ASPHALTAGE',
  Insurance = 'ASSURANCE',
  LawyersNotariesAndLegalServices = 'AVOCAT, NOTAIRE ET SERVICE JURIDIQUE',
  Balcony = 'BALCON',
  ConcreteAndMasonry = 'BÉTON ET MAÇONNERIE',
  ChargingStation = 'BORNE DE RECHARGE',
  Sealing = 'CALFEUTRAGE',
  MaintenanceRecordAndReserveFund = "CARNET D'ENTRETIEN ET FONDS DE PRÉVOYANCE",
  Heating = 'CHAUFFAGE',
  Conditioning = 'CLIMATISATION',
  AccountingAndFinance = 'COMPTABILITÉ ET FINANCE',
  ConciergeServices = 'CONCIERGERIE',
  RebuildingCost = 'COÛT DE RECONSTRUCTION',
  RealEstateBroker = 'COURTIER IMMOBILIER',
  Mover = 'DÉMÉNAGEUR',
  Lighting = 'ÉCLAIRAGE',
  Edition = 'EDITION',
  Electricity = 'ELECTRICITÉ',
  VirtualMeeting = 'RÉUNION VIRTUELLE',
  GeneralContractor = 'ENTREPRENEUR GÉNÉRAL',
  Housekeeping = 'ENTRETIEN MÉNAGER',
  BuildingEvaluator = 'EVALUATEUR EN BATIMENT',
  CertifiedAppraiser = 'EVALUATEUR AGRÉÉ',
  BuildingConsultant = 'EXPERT CONSEIL EN BÂTIMENT',
  ClaimsAdjuster = 'EXPERT EN SINISTRE',
  Window = 'FENÊTRE',
  Fireplace = 'FOYER',
  NaturalGaz = 'GAZ NATUREL',
  Generator = 'GÉNÉRATRICE',
  TechnicalProjectManagement = 'GESTION DE PROJET TECHNIQUE',
  ParkingManagement = 'GESTION DE STATIONNEMENT',
  FinancialAndAdministrativeManagement = 'GESTION FINANCIÈRE ET ADMINISTRATIVE',
  LocationManagement = 'GESTION LOCATIVE',
  PestManagement = 'GESTION PARASITAIRE',
  Manager = 'GESTIONNAIRE',
  SmallCopropertyManager = 'GESTIONNAIRE PETITE COPROPRIÉTÉ',
  Gutter = 'GOUTTIERE',
  Infiltration = 'INFILTRATION',
  Engineer = 'INGENIEUR',
  Inspection = 'INSPECTION',
  FacadeInspection = 'INSPECTION DE FAÇADE',
  DroneInspection = 'INSPECTION PAR DRONE',
  ThermalInspection = 'INSPECTION THERMIQUE',
  FinancialInstitution = 'INSTITUTION FINANCIÈRE',
  IntercomAndAccessControl = 'INTERCOM ET CONTRÔLE D\'ACCÈS',
  Internet = 'INTERNET',
  Delivery = 'LIVRAISON',
  Software = 'LOGICIEL',
  BalconyAndParkingMembrane = 'MEMBRANE BALCON ET STATIONNEMENT',
  AirConditionerCleaning = 'NETTOYAGE AIR CLIMATISÉ',
  CeramicCleaning = 'NETTOYAGE CÉRAMIQUE',
  DryerDuctCleaning = 'NETTOYAGE CONDUIT DE SÉCHEUSE',
  VentilationCleaning = 'NETTOYAGE VENTILATION',
  CleaningAndMaintenance = 'NETTOYAGE ET ENTRETIEN',
  CleaningAndPumpingOfSepticTanks = 'NETTOYAGE ET POMPAGE DE PUISARD',
  ParkingCleaning = 'NETTOYAGE STATIONNEMENT',
  CarpetCleaning = 'NETTOYAGE TAPIS',
  WindowCleaning = 'NETTOYAGE VITRE',
  Tools = 'OUTILLAGE',
  Painter = 'PEINTRE',
  WindowFilm = 'PELLICULE POUR FENÊTRE',
  SwimmingPool = 'PISCINE',
  Plumbing = 'PLOMBERIE',
  GarageDoors = 'PORTES DE GARAGE',
  DoorsAndWindows = 'PORTES ET FENETRES',
  WaterDamagePrevention = "PRÉVENTION DÉGAT D'EAU",
  IndoorAirQuality = 'QUALITÉ D’AIR INTERIEUR',
  ConstructionQuality = "QUALITÉ DANS LA CONSTRUCTION",
  ConstructionDebrisCollection = 'RAMASSAGE DE DÉBRIS DE CHANTIER',
  RenovationAndSmallJobs = 'RÉNOVATION ET PETITS TRAVAUX',
  ApplianceRepair = 'RÉPARATION ÉLECTROMÉNAGER',
  FireSecurity = 'SÉCURITÉ INCENDIE',
  Locksmith = 'SERRURIER',
  ArboriculturalServices = 'SERVICES ARBORICOLES',
  HealthAndHelpService = 'SERVICE DE SANTÉ ET D\'AIDE',
  EnergyService = 'SERVICE ÉNERGETIQUE',
  RealEstateServices = 'SERVICES IMMOBILIERS',
  Claims = 'SINISTRE',
  Parking = 'STATIONNEMENT',
  SecuritySystem = 'SYSTÈME DE SÉCURITÉ',
  Technology = 'TECHNOLOGIE',
  HeatPump = 'THERMOPOMPE',
  Roofing = 'TOITURE',
  Ventilation = 'VENTILATION'
}

export class ActivityAreaHelper {
  static values(): string[] {
    return Object.keys(ActivityArea).filter((item) => isNaN(Number(item)))
  }

  static translatedValues(): string[] {
    return this.values().map(x => i18n.t(`organization.activityArea.${x.makeFirstLetterLowercase()}`))
  }

  static activityAreaFormOptions(): FormOption[] {
    return this.values().map(activityArea => {
      return {
        name: this.getActivityAreaValueOfKey(activityArea),
        label: i18n.t(`organization.activityArea.${activityArea.makeFirstLetterLowercase()}`)
      } as FormOption
    });
  }

  static convertActivityAreaKeysToFormOptions(activityAreas: string[]): FormOption[] {
    return activityAreas
      .filter(x => this.translatedValues().includes(x))
      .map(activityArea => {
        return {
          name: activityArea,
          label: i18n.t(`organization.activityArea.${this.getKeyOfActivityAreaValue(activityArea).makeFirstLetterLowercase()}`)
        } as FormOption
      }).sortByLabel()
  }

  static getActivityAreaValueOfKey(key: string) {
    // eslint-disable-next-line
    return Object.entries(ActivityArea).find(([k, _]) => k.toUpperCase() === key.toUpperCase())?.[1]
  }

  static getKeyOfActivityAreaValue(value: string) {
    return Object.keys(ActivityArea)[Object.values(ActivityArea).indexOf(value as ActivityArea)];
  }
}